module.exports = __webpack_public_path__ + "98ae9a2da22c91cbaa7e2b5755d7f26b.png";